/** Packages * */
import React, { useEffect } from "react";
import { Provider } from "react-redux";
import { Route, Switch, Router, useLocation } from "react-router-dom";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import getMuiTheme from "material-ui/styles/getMuiTheme";
/** Scenes * */
// import Logout from './../../scenes/Logout/';
import Home from "./../../scenes/Home/";
import Settings from "./../../scenes/Settings/";
import Bidding from "./../../scenes/BidSession/";
import Reports from "./../../scenes/Reports/";
import ReportLoader from "./../../scenes/Reports/components/ReportLoader";
import History from "./../../scenes/History/History.jsx";
import PastSession from "./../../scenes/PastSession/";
import CrewGroupDefault from "./../../scenes/CrewGroupDefault/";
import { common, LAST_BID_SCOPE_USE } from "./../../data/constants/";
import Impersonate from "./../../scenes/Impersonate/";
import MainLayout from "./../Layouts/MainLayout";
import DefaultSettings from "./../../scenes/DefaultSettings/";
import ProtectedRoute from "./../ProtectedRoute/";
import store from "./../../store";
import appHistory from "../../appHistory";
import { Error500, SessionExpired } from "./../ErrorPages";
import { getLoginRoute } from "./helpers";

const customMUI = getMuiTheme({
  palette: {
    primary1Color: common.colors.CI_BLUE,
    primary2Color: common.colors.CI_BLUE,
    pickerHeaderColor: common.colors.CI_BLUE,
  },
});

const useTrackUrlChange = () => {
  const location = useLocation();

  useEffect(() => {
    // Reset the last bid scope use when the URL changes
    const oldValue = sessionStorage.getItem(LAST_BID_SCOPE_USE);
    sessionStorage.setItem(LAST_BID_SCOPE_USE, "");

    // Dispatch custom event to notify components about the change
    window.dispatchEvent(
      new CustomEvent("lastBidScopeUsedChanged", {
        detail: { oldValue: oldValue, newValue: "" },
      })
    );

    console.log(`URL changed to: ${location.pathname}`);
  }, [location]);
};

// Component to track URL changes using the custom hook
const TrackUrlChange = () => {
  useTrackUrlChange();
  return null;
};

const loginRoute = getLoginRoute();
const App = () => {
  return (
    <MuiThemeProvider muiTheme={customMUI}>
      <Provider store={store}>
        <Router history={appHistory}>
          <TrackUrlChange />
          <Switch>
            <Route
              exact
              path={`${loginRoute.path}`}
              component={loginRoute.component}
            />
            {/* <Route exact path="/logout" component={Logout} /> */}
            <Route
              path="/report-loader/:uniqueIdentifier"
              component={ReportLoader}
            />
            <MainLayout>
              <Route path="/home" component={Home} />
              <Route path="/bid-session/:bidId" component={Bidding} />
              <Route path="/reports" component={Reports} />
              <Route path="/history" component={History} />
              <Route path="/settings" component={Settings} />
              <ProtectedRoute path="/impersonate" component={Impersonate} />
              <ProtectedRoute path="/crew-group-default" component={CrewGroupDefault} />
              <Route
                path="/help"
                component={() => {
                  const hostname = window.location.hostname;
                  // eslint-disable-next-line eqeqeq
                  // Added for checking localhost application url
                  if (hostname !== "localhost") {
                    window.location.href = window.helpUrl;
                  } else {
                    window.location.href = "/assets/help/Content/Home.htm";
                  }
                  return null;
                }}
              />
              <Route path="/default-settings" component={DefaultSettings} />
              <Route path="/history/:sessionId" component={PastSession} />
              <Route path="/500" component={Error500} />
            </MainLayout>
          </Switch>
        </Router>
      </Provider>
    </MuiThemeProvider>
  );
};
export default App;
